<template>
    <div class="c-term component">
        <h3 class="text-upper">PREFEROWANY TERMIN</h3><br>
        <template v-if="lead.dealer_id">
            <template v-if="addminssionTermsLoading">
                <img src="@/assets/g0R5.gif" alt="ładowanie proszę czekać" class="c-term__loading">
                <br>
                Szukamy dla Ciebie najlepszego terminu.
            </template>
            <template v-else-if="!addminssionTermsLoading && getAvailableTerms && getAvailableTermsMiddleware">
                <span class="label mb--2">
                    Na podstawie danych wprowadzonych przez Ciebie możemy zaoferować następujące wizyty.
                    Kliknij aby wybrać wizytę.
                </span>
                <v-calendar :columns="$screens({ default: 1, lg: 2 })" is-expanded mode="date"
                    @dayclick="onDayClick"
                    :available-dates="getCalendarAvailableDates"
                    v-model="calenadrDate">
                </v-calendar>
                <div class="flex-row flex-row--end flex-gap--1 pb-2">
                    <span v-if="addminssionTermsLoadingMore" class="mt--2">
                        <img src="@/assets/g0R5.gif" alt="ładowanie proszę czekać" class="c-term__loading"
                            style="width: 15px;">
                        Proszę czekać trwa pobieranie...
                    </span>
                    <template v-if="!addminssionTermsLoadingMore">
                        <button class="btn mt--1"
                            :disabled="isService259"
                            v-on:click="lead.date_from = getFirstAvaibleDateByTerms; fetchTerms(); addminssionTermsLoadingMore = true">←</button>
                        <span class="mt--2">Zakres od <b>{{ lead.date_from }}</b> do <b>{{ getLastAvaibleDateByTerms }}</b></span>
                        <button class="btn mt--1"
                            :disabled="isService259"
                            v-on:click="lead.date_from = getLastAvaibleDateByTerms; fetchTerms(); addminssionTermsLoadingMore = true">→</button>
                    </template>
                </div>
                <div class="flex-row flex-row--center flex-gap--1 pb-2">
                    <button :class="[`btn mt--1`, { 'btn--primary': lead.visit_hour_name === timeOfDay.name }]"
                        v-for="timeOfDay in getTimeOfDayWithDealersHours" :key="timeOfDay.name" v-on:click="lead.visit_hour_val = timeOfDay.val; lead.date_hour_from = nextTime; lead.hour_to = timeOfDay.term.hour_to; lead.visit_hour_name = timeOfDay.name; fetchTerms(); addminssionTermsLoading = true
                            ">{{ timeOfDay.name }}</button>
                </div>
                <div class="pb--2 pt--2">
                    <div class="flex-row flex-gap--1">
                        <div class="flex-col">
                            <TypeSelect :options="getAvaibleHoursFromTerms"
                                :input="{ disabled: false, placeholder: 'Godzina', sufix: '' }"
                                v-on:selectValue="searchHour = $event.value">
                                <template slot-scope="{option}">{{ option.name }}</template>
                            </TypeSelect>
                        </div>
                        <div class="flex-col">
                            <TypeSelect :options="getAvaibleUserNamesFromTerms"
                                :input="{ disabled: false, placeholder: 'Doradca serwisowy', sufix: '' }"
                                v-on:selectValue="searchPerson = $event.value">
                                <template slot-scope="{option}">{{ option.name }}</template>
                            </TypeSelect>
                        </div>
                    </div>
                </div>
                <div v-if="lead.date_from">
                    <div class="c-term__item flex-row pointer" v-for="(term, key) in getAvailableTermsFiltered"
                        v-on:click="chooseTerm(term, key)" :key="key" v-if="key <= perpage * (page + 1)">
                        <div class="flex-col flex-col--3 pr--1 mr--2">
                            <small>
                                <br />
                                {{ term.dayshortname }}
                                {{ term.date }}
                                <br />
                                {{ term.hour }}
                            </small>
                        </div>
                        <div class="flex-col flex-col--6 mt--1">
                            <img src="@/assets/localizations.jpg" alt="Localization" class="c-term__icon" />
                            <h3>{{ getSelectedDealer && getSelectedDealer.name ? getSelectedDealer.name : null }}</h3>
                            <span class="c-term__person">Doradca serwisowy: {{ term.user_name }}</span>
                        </div>
                    </div>
                    <button class="btn" v-on:click="page++"
                        v-if="perpage * (page + 1) < getAvailableTermsFiltered.length">
                        ▼ Pokaż kolejne
                    </button>
                </div>
            </template>
            <template v-else>
                <h3>
                    <br>
                    Nie jesteśmy w stanie zaproponować terminów dla podanych kryteriów.
                </h3>
            </template>
        </template>
        <template v-else>
            <p class="text-alert">Proszę wybrać serwis.</p>
        </template>
    </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import lead from "@/mixins/lead.js";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

import TypeSelect from '../elements/type-select.vue'

export default {
    data() {
        return {
            calenadrDate: null,
            page: 0,
            perpage: 8,
            addminssionTermsLoading: true,
            searchHour: null,
            searchDay: null,
            searchPerson: null
        }
    },
    mixins: [lead],
    components: {
        DatePicker,
        TypeSelect
    },
    computed: {
        ...mapGetters({
            getDealers: "definitions/getDealers",
            getAvailableTerms: "definitions/getAvailableTerms",
            getTimeOfDayWithDealersHours: "definitions/getTimeOfDayWithDealersHours",
            getDetepickerConfig: "definitions/getDetepickerConfig",
            getServices: "definitions/getServices"
        }),
        isService259() {
            return this.lead.services_val && (this.lead.services_val.includes(259) || this.lead.services_val.includes('259'));
        },
        getSelectedDealer() {
            return this.getDealers.find((e) => e.id == this.lead.dealer_id);
        },
        getAvailableTermsMiddleware() {
            return this.getAvailableTerms ? this.getAvailableTerms
            .map(term => {
                return {
                    ...term,
                    dayname: this.getDayNameOfWeek(term.date),
                    dayshortname: this.getDetepickerConfig.formatLocale.weekdaysShort[this.getDayofWeek(term.date)],
                }
            }) : [];
        },
        getAvaibleDatesByTerms() {
            return [...new Set(this.getAvailableTermsMiddleware.map(item => item.date))]
        },
        getCalendarAvailableDates() {
            if (this.isService259) {
                let year = new Date().getFullYear();
                if (this.getAvaibleDatesByTerms && this.getAvaibleDatesByTerms.length > 0) {
                    year = parseInt(this.getAvaibleDatesByTerms[0].split('-')[0]);
                }
                
                return [
                    { start: new Date(year, 9, 31), span: 1 },  // 31 października
                    { start: new Date(year, 10, 7), span: 1 },  // 7 listopada
                    { start: new Date(year, 10, 14), span: 1 }, // 14 listopada
                    { start: new Date(year, 10, 21), span: 1 }  // 21 listopada
                ];
            }

            let dates = this.getAvaibleDatesByTerms;
            
            const blockedDates = ['-10-31', '-11-07', '-11-14', '-11-21'];
            dates = dates.filter(date => !blockedDates.some(d => date.endsWith(d)));

            if (!dates || dates.length === 0) {
                return [{ start: new Date(1970, 0, 1), span: 1 }];
            }

            return dates.map(e => {
                const [y, m, d] = e.split('-');
                return { start: new Date(y, m - 1, d), span: 1 };
            });
        },
        getFirstAvaibleDateByTerms() {
            if (!this.getAvaibleDatesByTerms.length) return this.lead.date_from;
            const date = new Date(this.getAvaibleDatesByTerms.at(0));
            date.setDate(date.getDate() - 16);
            const formattedDate = date.toISOString().split('T')[0];
            return formattedDate;
        },
        getLastAvaibleDateByTerms() {
            if (!this.getAvaibleDatesByTerms.length) return this.lead.date_from;
            return this.getAvaibleDatesByTerms.at(-1)
        },
        getAvailableTermsByDay() {
            return (day) => {
                return this.getAvailableTermsMiddleware.filter(item => day === item.date)
            }
        },
        getAvailableTermsFiltered() {
            return this.getAvailableTermsByDay(this.lead.date_from).filter((term) => {
                return (!this.searchHour || term.hour == this.searchHour) &&
                    (!this.searchPerson || term.user_name.trim() == this.searchPerson) &&
                    (!this.searchDay || term.dayname == this.searchDay);
            });
        },
        getAvaibleHoursFromTerms() {
            return [
                { name: 'Wszystkie', value: null },
                ...this.getAvailableTermsByDay(this.lead.date_from).map(term => ({
                    name: term.hour,
                    value: term.hour
                })).reduce((acc, current) => {
                    const x = acc.find(item => item.value == current.value);
                    if (!x) {
                        return acc.concat([current]);
                    } else {
                        return acc;
                    }
                }, []).sort((a, b) => Number(a.value.replace(':', '.')) - Number(b.value.replace(':', '.')))
            ]
        },
        getAvaibleDaysFromTerms() {
            return [
                { name: 'Wszystkie', value: null },
                ...this.getAvailableTermsByDay(this.lead.date_from).map(term => ({
                    name: term.dayname,
                    value: term.dayname
                })).reduce((acc, current) => {
                    const x = acc.find(item => item.value == current.value);
                    if (!x) {
                        return acc.concat([current]);
                    } else {
                        return acc;
                    }
                }, [])
            ]
        },
        getAvaibleUserNamesFromTerms() {
            return [
                { name: 'Wszystkie', value: null },
                ...this.getAvailableTermsByDay(this.lead.date_from).map(term => ({
                    name: term.user_name.trim(),
                    value: term.user_name.trim()
                })).reduce((acc, current) => {
                    const x = acc.find(item => item.value == current.value);
                    if (!x) {
                        return acc.concat([current]);
                    } else {
                        return acc;
                    }
                }, [])
            ]
        }
    },
    methods: {
        ...mapActions({
            fetchServiceAdmissionTerms: "definitions/fetchServiceAdmissionTerms",
        }),
        onDayClick(day) {
            if (day.isDisabled) return;
            this.lead.date_from = day.id;
        },
        chooseTerm(term, key) {
            this.lead.date = term.date;
            this.lead.hour = term.hour;
            this.lead.advisor_id = term.user_id;
            this.lead.term_key = key;
            this.lead.repair = term.mechanic_term;
            this.lead.mechanic_id = term.mechanic_term.mechanic_id;
            this.lead.mechanic_hour = term.mechanic_term.hour;
            this.lead.mechanic_date = term.mechanic_term.date;
            this.lead.advisor_name = term.user_name;
            this.lead.termData = term;
            this.$router.push({ path: "client" });
        }
    },
    created() {
        this.fetchTerms();
    }
}
</script>
<style lang="scss">
.c-term {
    &__item {
        border-left: 5px solid $green;
        padding-left: 0.5rem;
        margin-bottom: 2rem;

        .flex-col {
            position: relative;

            &:first-of-type::after {
                content: " ";
                display: block;
                background: $green;
                height: 86px;
                width: 0;
                position: absolute;
                top: -0.5rem;
                left: -1rem;
                z-index: -1;
                transition: width 0.25s linear;
            }
        }

        &:hover {
            & .flex-col:first-of-type {
                color: $white;

                .c-term__suggestion {
                    color: $white;
                }

                &::after {
                    width: calc(100% + 6rem);
                }
            }
        }
    }

    &__loading {
        filter: invert(1);
        width: 44px;
    }

    &__icon {
        width: 22px;
        height: 22px;
    }
}
</style>